import { render, staticRenderFns } from "./spider-select.vue?vue&type=template&id=5844233a&scoped=true&"
import script from "./spider-select.vue?vue&type=script&lang=ts&"
export * from "./spider-select.vue?vue&type=script&lang=ts&"
import style0 from "./spider-select.vue?vue&type=style&index=0&id=5844233a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5844233a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VDataTable,VPagination})
